import React, { PureComponent } from "react";
//import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Nexoid_Agent_SSO extends PureComponent {
  render() {
    return (
      <div>
        <div className="row" id="nexoid_agent_sso">
          <div className="col-md-6">
            <div className="contentLight">
              <section>
                <h2>Nexoid Agent SSO</h2>
                <p>
                  The Nexoid Agent console application provides the webservices required for single sign on (SSO). To setup SSO start by installing the Nexoid Agent and following the Active Directory Integration instructions.
                </p>
                <p>SSO is made up of two discrete web services. The first is used by users inside your private network to automatically sign them into Nexoid using the same account they are logged into windows with. This is called the SSO service. The second is used by users inside and outside your private network and allows users to enter their Active Directory username and password allowing users to sign in from devices not connected to Active Directory. This is known as the Authentication service.</p>
              </section>
            </div>
          </div>
          <div className="col-md-6 darkCol">
          </div>
        </div>
        <div className="row" id="nexoid_agent_sso">
          <div className="col-md-6">
            <div className="contentLight">
              <section>
                <h3>SSO Service</h3>
                <p>The SSO service is only accessible on your private network and requires an SSL certificate. There are multiple ways to achieve this, however, Nexoid recommends using an open SSL certificate. Open SSLs can be created by anyone and are free to use. To make an Open SSL certificate work on a Windows domain you will need to generate a certificate authority key and configure Active Directory to trust it. You will then need to generate a server SSL and place it in the same directory as the Nexoid Agent. </p>
                <p>Bellow or to the right of this document you will see a setup by set instructions for creating an SSL using Open SSL.</p>
                <h3>Configure Active Directory with myCA.pem</h3>
                <p>After following the instruction to create a myCA.pem and ssoserver.cert you will need to tell Active Directory to trust myCA.pem.  Please follow the below instructions.</p>
                <div className="wInstruct">Type WIN+R {"-->"} type "MMC" {"-->"} Press Enter</div>
                <div className="wInstruct">Click File {"-->"} Add/Remove Snap-in</div>
                <div className="wInstruct">Click Certificates {"-->"} Add {"-->"} My user account {"-->"} Finish {"-->"} OK</div>
                <div className="wInstruct">Navigate to "Console Root" / "Certificates - Current User" / "Trusted Root Certification Authorities" / "Certificates"</div>
                <div className="wInstruct">Click Action (top menu) {"-->"} Import {"-->"} Next</div>
                <div className="wInstruct">Browse to myCA.pem {"-->"} Next</div>
                <div className="wInstruct">Place all certificates in follow store (Trusted Root Certification Authorities)</div>
                <div className="wInstruct">Click Next {"-->"} Finish</div>
                <p>Now we need to set group policy to push out the certificate to all domain users</p>
                <div className="wInstruct">Create a share that is accessible to all domain users<br />
                  -make sure to remove "everyone"<br />
                  -add "domain users" read access<br />
                  -remember to set permissions for both share and NTFS files system under security</div>
                <div className="wInstruct">Test that share is accessible on a user account on a user computer<br />
                  WIN+R {"-->"} \\Server2012AD\certshare</div>
                <div className="wInstruct">
                  Open Group Policy Manager<br />
                  Navigate to "Forest:westwood.com" / "Domains" / "Group Policy Objects"<br />
                  Action (top menu) {"-->"} New {"-->"} enter name (NexoidSSOSSLCert) {"-->"} OK<br />
                  Right click NexoidSSOSSLCert {"-->"} Edit<br />
                  Navigate to "Computer Configuration"/ "Policies" / "Windows Settings" / "Security Settings" / "Public Key Policies"<br />
                  Right click "Trusted Root Certification Authorities" {"-->"}Import {"-->"} Next<br />
                  Enter the network share file path "\\Server2012AD\certshare\myCA.pem"  {"-->"} Next<br />
                  Make sure corticates store is "Trusted Root Certification Authorities" {"-->"} Next<br />
                  Finish<br />
                  Drag "NexoidSSOSSLCert" from "Group Policy Objects" to westwood.com<br />
                  Right click "NexoidSSOSSLCert" click "Enforce"<br />
                  Certificate will install next time user logs in<br />
                </div>
              </section>
            </div>
          </div>
          <div className="col-md-6 darkCol">
            <div className="contentDark">
              <section>
                <h2>SSO Service Setup</h2>
              </section>
              <section>
                <h3>Step 1: Install Git Bash</h3>
                <p>Click on the link .</p>
                <div className="darkCode padBot">
                  <div><a href="https://git-scm.com/downloads" target="_blank" style={{ color: '#e6db74' }}>https://git-scm.com/downloads</a></div>
                </div>
                <h3>Step 2: Create Certificate Authority</h3>
                <p>Create a folder on your desktop and right click it, and click “Git Bash Here”. Then type the line below and follow the instructions.</p>
                <div className="darkCode padBot">
                  <div><span className="jsonY">winpty openssl genrsa -des3 -out myCA.key 2048</span></div>
                </div>

                <h3>Step 3: Create CA pem</h3>
                <p>Generate a pem from the CA key</p>
                <div className="darkCode padBot">
                  <div><span className="jsonY">winpty openssl req -x509 -new -nodes -key myCA.key -sha256 -days 1825 -out myCA.pem</span></div>
                </div>

                <h3>Step 4: Generate Server key from CA</h3>
                <div className="darkCode padBot">
                  <div><span className="jsonY">winpty openssl genrsa -out ssoserver.key 2048</span></div>
                </div>

                <h3>Step 5: Generate Server certificate from server key</h3>
                <div className="darkCode padBot">
                  <div><span className="jsonY">winpty openssl req -new -key ssoserver.key -out ssoserver.csr</span></div>
                </div>

                <h3>Step 6: Create Ext file</h3>
                <p>Create a "ssoserver.ext" file and copy the below code into it changing the DNS.1, DNS.2 and IP.1 lines.</p>
                <div className="darkCode padBot">
                  <div>authorityKeyIdentifier=keyid,issuer</div>
                  <div>basicConstraints=CA:FALSE</div>
                  <div>keyUsage = digitalSignature, nonRepudiation, keyEncipherment, dataEncipherment</div>
                  <div>subjectAltName = @alt_names</div>
                  <div><br /></div>
                  <div>[alt_names]</div>
                  <div>DNS.1 = <span className="jsonY">Server2012AD.westwood.com</span></div>
                  <div>DNS.2 = <span className="jsonY">Server2012AD</span></div>
                  <div>IP.1 = <span className="jsonY">10.0.1.127</span></div>
                </div>


                <h3>Step 7: Cross sign Certificates</h3>
                <div className="darkCode padBot">
                  <div><span className="jsonY">winpty openssl x509 -req -in ssoserver.csr -CA myCA.pem -CAkey myCA.key -CAcreateserial -out ssoserver.crt -days 825 -sha256 -extfile ssoserver.ext</span></div>
                </div>

                <h3>Step 8: Copy Files</h3>
                <p>Copy ssoserver.key and ssoserver.crt to the Nexoid Agent folder.</p>
                <p>Import myCA.pem to Active Directory as a trusted certificate authority.</p>

              </section>
            </div>
          </div>
        </div>
        <div className="row" id="nexoid_agent_sso_auth_service">
          <div className="col-md-6">
            <div className="contentLight">
              <section>
                <h3>Authentication Service</h3>
                <p>The authentication server needs to be accessible from the public internet. To do this you will need to forward a port on your router / firewall. </p>
                <Footer
                  section={this.props.section}
                  article={this.props.article}
                  routeParams={this.props.routeParams}
                />
              </section>
            </div>
          </div>
          <div className="col-md-6 darkCol">
            <div className="contentDark">
              <section>
                <h2>Authentication Service Port Forwarding</h2>
              </section>
              <section>
                <h3>Example Port Forwarding Rule:</h3>
                <p>This example forwards the port 8989 on the public IP address 123.123.123.123 to a private server running Nexoid Agent.</p>
                <div className="darkCode">
                  <div>
                    <span className="jsonY">123.123.123.123:8989 {"-->"} 10.0.1.127:8989</span></div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Nexoid_Agent_SSO;



// WEBPACK FOOTER //
// ./src/components/knowlege/integration/Nexoid_Agent_SSO.js